import React, { useEffect } from "react";
import "./Contact.css";

function Contact({ setHome, setAboutMe, setContact }) {
  useEffect(() => {
    setHome(false);
    setAboutMe(false);
    setContact(true);

    return () => {
      setHome(true);
      setAboutMe(true);
      setContact(true);
    };
  }, [setHome, setAboutMe, setContact]);

  return (
    <>
      <div className="contacts-container">
        <div className="box" style={{ color: "#3f51b5" }}>
          <div className="face front">
            <i className="fa-solid fa-envelope"></i>
          </div>
          <div className="face back email">
            <span>abbasluay1981@gmail.com</span>
          </div>
        </div>
        <div className="box" style={{ color: "#f44336" }}>
          <div className="face front">
            <i className="fa-solid fa-map-location-dot"></i>
          </div>
          <div className="face back" style={{ flexDirection: "column" }}>
            <div></div>
            <div></div>
          </div>
        </div>
        <div className="box" style={{ color: "#607d8b" }}>
          <div className="face front">
            <i className="fa-solid fa-phone"></i>
          </div>
          <div className="face back"></div>
        </div>
        <div className="github">
          <a
            href="https://github.com/Luayabbas1981?tab=repositories"
            target="_blank"
            rel="noopener noreferrer"
          >
            {" "}
            <i
              className="fa-brands fa-github-alt"
              style={{ color: "#673ab7" }}
            ></i>
          </a>
        </div>
        <div className="linkedin">
          <a
            href="https://www.linkedin.com/in/luay-abbas-79531a24a/"
            target="_blank"
            rel="noopener noreferrer"
          >
            <i
              className="fa-brands fa-linkedin-in"
              style={{ color: "#2196f3" }}
            ></i>
          </a>
        </div>
      </div>
    </>
  );
}

export default Contact;
